import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    feeType: [
      {
        const: '1',
        title: 'درصد',
      },
      {
        const: '2',
        title: 'ثابت',
      },
    ],
  },
  reducers: {
    setFeeType: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        feeType: payload,
      };
    },
  },
});

export const { setFeeType } = appSlice.actions;

export default appSlice.reducer;
